import React, {useEffect, useState} from "react";
import Layout from "../../../components/mobile/Layout/layoutmobile";
import { TabView, TabPanel } from 'primereact/tabview';
import {getBenefit,getCondition,getInfo} from "../../../service/loyaltyService";
import { FromatNumberVIE} from "../../../utils/format";
import {isAuth} from "../../../helpers/general";
import HeaderMobile from "../../../components/mobile/header/headerv2";
import { pushtracking } from "../../../service/trackingService";
import { useLocation } from "@reach/router";

import "./css/dacquyen.css";
const Dacquyen = ()=>{
    // if (isAuth() === false) {
    //     navigate('/mobile/login.html');
    //   }
    const location = useLocation();
    const [benefit, setBenefit] = useState([]);
    const [condition, setCondition] = useState([]);
    const [cardCode, setCardCode] = useState();
    // let cardCode = window.localStorage.getItem('cardcode');
    const getDataBenefit=()=>{
        getBenefit().then((response)=>{
            setBenefit(response['message']);
        })
    };
    const [cardnow, setCardNow] = useState([]);
    const [cardName, setCardName] = useState([]);
    const [cardClassCode, setClassCode] = useState([]);
    const [cardup, setCardUp] = useState([]);

    const getDataCondition=()=>{
        getCondition().then((response)=>{
            console.log(response['message']);
            setCondition(response['message']);
            response['message']?.forEach((item) => {
                if(+item.class_code === +cardCode){
                    setCardNow(item);
                }
                if(+item.class_code === +cardCode+1){
                    setCardUp(item);
                }
            });
            
        })
    };
    const [collect, setCollect] = useState(0);
    const getDataInfo=()=>{
        if(window.localStorage.getItem('key') && window.localStorage.getItem('key') !== ''){
            getInfo(window.localStorage.getItem('key')).then((response)=>{
                window.localStorage.setItem('cardname', response['message'].dataCard?.class_name);
                setCardName(response['message'].dataCard?.class_name);
                setClassCode(response['message'].dataCard?.class_code);
                window.localStorage.setItem('cardcode', response['message'].dataCard?.class_code);
                window.localStorage.setItem('collect', parseInt(response['message'].dataProcess?.collect,0));
                setCollect(parseInt(response['message'].dataProcess?.collect,0));
            });
        }
        
    };
    const [bixu, setBixu] = useState();
    useEffect(()=>{
        if(window.localStorage.getItem('bixu') && window.localStorage.getItem('bixu') !== null  && window.localStorage.getItem('bixu') !== undefined){
            setBixu(FromatNumberVIE(window.localStorage.getItem('bixu')));
        }
        setCardCode(window.localStorage.getItem('cardcode'));
        getDataInfo();
        getDataBenefit();
        getDataCondition();
        try{
            pushtracking(window.localStorage.getItem('sessionId')??null,
            window.localStorage.getItem('_id')??null,
            window.localStorage.getItem('phone')??null ,
            location.pathname, "Đặc quyền của bạn", 0,0,'index','inWeb',[],'Website Mobile').then((response)=>{
                console.log('send tracking');
            });
        }catch(e){console.log(e)}
    },[]);
    
    const handleLogout = () => {
        localStorage.clear();
        window.location.href = '/dang-nhap.html';
      }

    const handleRegulation = () => {
    window.location.href = '/dem-xu-ngay-doi-qua-lien-tay.html';
    }
    return(
        <Layout>
            <HeaderMobile Type={'HeaderDacQuyen'} showBanner={false} linkBanner="" showText = {true} showSearchIcon= {true} showNoti = {true} showCart = {true} showTitle = {"Đặc quyền của bạn"} /> 
            <div id="dacquyen" className="personal bg-index">
                {
                    isAuth() === true ?(
                <div className="mgt-10 bg-white">
                </div>
                    ) : (
                        <div className="pdy-10 mgt-10 bg-white">
                            <div className="row mt-2">
                                <div className="col-12 flex-center">
                                    <button className="btn btn-dark w-50 text_12" onClick={handleLogout}>Đăng nhập/Đăng ký</button>
                                </div>
                            </div>
                            <div className="row mt-2">
                                <div className="col-12 flex-center text_14 font_500">
                                    <span>Để nhận đặc quyền dành riêng cho thành viên</span>
                                </div>
                            </div>
                        </div>
                    )
                }

                <div className="privilege-grade">
                    <div className="row mgt-10 pdy-20 bg-white mgx-0">
                        <div className="col-12 flex-center">
                            <strong className="text_header">QUYỀN LỢI THEO HẠNG</strong>
                        </div>
                    </div>
                    <div className="row bg-white mgx-0">
                        <div className="col-12 pdx-0">
                            <div className="privilege-tab ">
                                <TabView>
                                    {benefit ? (
                                        benefit.map((item,i)=>{
                                            return <TabPanel key={i} header={
                                                                <span className="flex-center text_14 color_gray">
                                                                    <img src={item.class_icon} shape="circle" alt="icon"/>
                                                                    <span className="text_12  font_700">{(+item.class_code === 2 || +item.class_code === 3) ? ('Hạng '+ item.class_name) : (item.class_name)}</span>
                                                                </span>
                                                            }>
                                                                <div className="tab-contents content1 active-tab font_500 pdx-24 pdt-20" id="close_class">
                                                                    {
                                                                        item.benefits?.map((itemlist,j)=>{
                                                                            return <div key={j} className="row col-12 mgt-15">
                                                                                <div className="col-2 in-f pdb-10 pdx-0">
                                                                                    <img className="icon-chill-class" src={itemlist.icon} alt="icon" />
                                                                                </div>
                                                                                <div className="col-10 div_custom pdb-5 font_500s pdx-0">
                                                                                    <div className="col-12"><span className="text_14">{itemlist.title}</span></div>
                                                                                    <div className="col-12"><span className="text_12 color_gray">{itemlist.description}</span></div>
                                                                                </div>
                                                                            </div>
                                                                        })
                                                                    }
                                                                </div>
                                                    </TabPanel>
                                        })
                                        ):(null)
                                    }
                                </TabView>
                            </div>
                        </div>
                    </div>
                    <div className="row bg-white personal-nuti-warning pdt-20 pdb-10 mgx-0">
                        <div className="col-12 pdx-30 position-relative">
                            <div className="card-custom">
                                <div className="card-body card_noti text_12 font_400 pdy-10 pdr-20">
                                    <ul>
                                        <li className="">Đặc quyền áp dụng 90 ngày từ ngày thăng hạng</li>
                                        <li className="">Ba Mẹ cần đảm bảo doanh số mua hàng tối thiểu của hạng trong kỳ xét hạng để duy trì hạng.</li>
                                    </ul>
                                </div>
                                <span className="position-absolute round-noti top-0 translate-middle">
                                    <img className="w-75" src="/../images/privilege/noti.svg" alt="icon"/>
                                    <span className="visually-hidden">unread messages</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    condition.length > 0 ? (
                        <div className="proviso">
                    <div className="row mgt-10 pdy-20 bg-white">
                        <div className="col-12 flex-center">
                            <strong className="text_header">ĐIỀU KIỆN THĂNG HẠNG</strong>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="privilege-tab tab-1">
                                <TabView>
                                    {
                                       condition.length > 0 ? (
                                            condition.map((item,i)=>{
                                            return <TabPanel key={i} header={
                                                                <span className="flex-center text_14 color_gray">
                                                                    <img src={item.class_icon} shape="circle" alt={item.name}/>
                                                                    <span className="text_12  font_700">{(+item.class_code === 2 || +item.class_code === 3) ? ('Hạng '+ item.class_name) : (item.class_name)}</span>
                                                                </span>
                                                            }>
                                                                <div className="tab-contents content1 active-tab font_500 pdx-24 pdy-10 pdt-20 bg-white" id="close_class">
                                                                    {
                                                                        item.conditions?.map((itemlist,j)=>{
                                                                            return <div key={j} className="row col-12 mgt-15">
                                                                                <div className="col-2 in-f pdb-10">
                                                                                    <img className="icon-chill-class" src={itemlist.title_icon} alt="icon" />
                                                                                </div>
                                                                                <div className="col-10 div_custom pdb-5 font_500s mgx-0">
                                                                                    <div className="col-12"><span className="text_12 color_gray">{itemlist.detail}</span></div>
                                                                                </div>
                                                                            </div>
                                                                        })
                                                                    }
                                                                </div>
                                                                <div className="row text_12 bg-white pdx-24 pdy-20 mgx-0">
                                                                    <div className="col-3 in-f">
                                                                        <span className="font_600">{cardName}</span>
                                                                    </div>
                                                                    <div className="col-6 flex-center">
                                                                        <span className="font_400 color_gray">Ba Mẹ cần mua</span>
                                                                        <span className="font_400 color_gray">
                                                                            <span className="text-danger font_600">
                                                                                &nbsp; +
                                                                                {
                                                                                    + collect > 1 ? 
                                                                                    (
                                                                                        +item?.buy_keep > 0 ? (FromatNumberVIE(item?.buy_keep-collect)):(FromatNumberVIE(item.buy_up-collect))
                                                                                    )
                                                                                    :
                                                                                    (
                                                                                        +item?.buy_keep > 0 ? (FromatNumberVIE(item?.buy_keep)):(FromatNumberVIE(item.buy_up))
                                                                                    )
                                                                                }
                                                                                 đ&nbsp;</span>
                                                                            để lên hạng</span>
                                                                            <div>
                                                                                <div className="col-md-6 line bgleft bgred"></div>
                                                                                <div className="col-md-6 line bgright"></div>
                                                                            </div>
                                                                    </div>
                                                                    <div className="col-3 in-f">
                                                                        <span className="font_600">
                                                                        {+cardClassCode>0 && i===0 ? (
                                                                            (+cardup['class_code'] === 2 || +cardup['class_code'] === 3) ? "Hạng " +condition[cardClassCode]?.class_name : condition[cardClassCode]?.class_name
                                                                        ):(
                                                                            (+cardup['class_code'] === 2 || +cardup['class_code'] === 3) ? "Hạng " +item.class_name : item.class_name
                                                                        )}
                                                                         
                                                                         </span>
                                                                    </div>
                                                                </div>
                                                            <div className="row bg-white personal-nuti-warning pdt-10 pdb-10 mgx-0">
                                                                <div className="col-12 pdx-30 position-relative">
                                                                    <div className="card-custom">
                                                                        <div className="card-body card_noti text_12 font_400 pdy-10 pdr-20">
                                                                            <ul>
                                                                                {
                                                                                    item.information?.map((iteminfo,k)=>{
                                                                                        return <li key={k} className="condition-info">{iteminfo.detail}</li>
                                                                                    })
                                                                                }
                                                                            </ul>
                                                                        </div>
                                                                        <span className="position-absolute round-noti top-0 translate-middle">
                                                                            <img className="w-75" src="/../images/privilege/noti.svg" alt="icon"/>
                                                                            <span className="visually-hidden">unread messages</span>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                    </TabPanel>
                                        })
                                        ):(null)
                                    }
                                </TabView>
                            </div>
                        </div>
                    </div>
                </div>
                     ):(null)
                }
                

                <div className="bg-white mgt-10 pdy-10">
                    <div className="row pdt-10">
                        <div className="col-12 flex-center">
                            <strong className="text_header">CÁC BƯỚC NHẬN ƯU ĐÃI</strong>
                        </div>
                    </div>
                    <div className="row mt-2 mgx-0">
                        <div className="col-12 pdx-24">
                            <div className="row position">
                                <div className="col-2 step-incentive in-f">
                                    <div className="step-get-incentive in-f">
                                        <div className="step-incentive-num in-f">
                                            <span>1</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-10 step-incentive-text pdt-5">
                                    <div className="col-12 d-flex">
                                        <span className="incentive-text-detail">Mua hàng, Săn Xu, Săn thưởng Xu</span>
                                    </div>
                                    <div className="col-12 d-flex">
                                        <span className="incentive-text-note">Làm nhiệm vụ, nhận thưởng Xu</span>
                                    </div>
                                </div>
                                <div className="step-content"></div>
                            </div>
                            <div className="row position mgy-10">
                                <div className="col-2 step-incentive in-f">
                                    <div className="step-get-incentive in-f">
                                        <div className="step-incentive-num in-f">
                                            <span>2</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-10 step-incentive-text pdt-5">
                                    <div className="col-12 d-flex">
                                        <span className="incentive-text-detail">Tích Bixu</span>
                                    </div>
                                    <div className="col-12 d-flex">
                                        <span className="incentive-text-note">1 Bixu = 1đ</span>
                                    </div>
                                </div>
                                <div className="step-content"></div>
                            </div>
                            <div className="row position">
                                <div className="col-2 step-incentive in-f">
                                    <div className="step-get-incentive in-f">
                                        <div className="step-incentive-num in-f">
                                            <span>3</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-10 step-incentive-text pdt-10">
                                    <span className="incentive-text-detail">Đổi quà</span>
                                </div>  
                            </div>
                        </div>   
                    </div>
                </div>
                <div className="bg-white pdy-20 pdx-24 mgt-10 mgx-0">
                    <div className="row mgx-10">
                        <div className="col-12 flex-center pdx-0">
                            <img src="/../images/privilege/dbstart.svg" alt="icon"/>
                            <strong className="text-danger">Ba Mẹ lưu ý!</strong>
                        </div>
                    </div>
                    <div className="row mgt-10 mgx-0">
                        <div className="col-1 flex-center pdx-0">
                            <img src="/../images/privilege/dbstart1.svg" alt="icon"/>
                        </div>
                        <div className="col-11 text_14 font_400 pdl-20">
                            <span>Đặc quyền trong Chính sách này không áp dụng đồng thời với các Ưu đãi và Chương trình Khuyến
                                mại khác.</span>
                        </div>
                    </div>
                    <div className="row mgt-10 mgx-0">
                        <div className="col-1 flex-center pdx-0">
                            <img src="/../images/privilege/dbstart1.svg" alt="icon"/>
                        </div>
                        <div className="col-11 text_14 font_400 pdl-20">
                            <span>Quà tặng Sinh nhật áp dụng cho 01 bé đối với hạng Thân thiết và hạng Bạc, cho 2 bé đối với
                                hạng Vàng và Kim Cương. Quà tặng áp dụng cho các Bé đến 6 tuổi và Ba Mẹ có phát sinh giao dịch
                                mua hàng kỳ D-90 trước ngày sinh nhật của Bé.</span>
                        </div>
                    </div>
                    <div className="row mgt-10 mgx-0">
                        <div className="col-1 flex-center pdx-0">
                            <img src="/../images/privilege/dbstart1.svg" alt="icon"/>
                        </div>
                        <div className="col-11 text_14 font_400 pdl-20">
                            <span>Nếu Ngày vàng Thành viên trùng vào các ngày Lễ Tết, hệ thống sẽ áp dụng Đặc quyền theo ngày Lễ
                                Tết để đảm bảo quyền lợi cao hơn cho Ba Mẹ.</span>
                        </div>
                    </div>
                    <div className="row mgt-10 mgx-0">
                        <div className="col-1 flex-center pdx-0">
                            <img src="/../images/privilege/dbstart1.svg" alt="icon"/>
                        </div>
                        <div className="col-11 text_14 font_400 pdl-20">
                            <span>Chính sách này do Công ty Cổ phẩn Bibo Mart TM ban hành. Có thể thay đổi từng thời điểm mà
                                không báo trước. Mọi thay đổi sẽ được thông tin tới Ba Mẹ qua thông báo trên
                                App/ZaloOA/Email/Facebook.</span>
                        </div>
                    </div>
                </div>
                <div className="row mt-3">
                        <div className="col-12 flex-center">
                            <button onClick={handleRegulation} className="btn btn-outline-dark  text_14">Xem thêm Quy định Tích & Tiêu Bixu</button>
                        </div>
                    </div>
                <div className="">
                    <div className="row mt-5">
                        <div className="col-12 flex-center-col">
                            <strong className="text_header">PHÒNG CHĂM SÓC KHÁCH HÀNG</strong>
                            <div className="text_14 font_500 color_gray">Công ty Cổ phần Bibo Mart TM</div>
                            <div className="text_14 font_500 color_gray">ZaloOA <span
                                    className="text-danger text_underline">BiboMart</span>
                            </div>
                            <div className="text_14 font_500 color_gray">Hotline: <span className="text-danger">1800 6886</span></div>
                        </div>
                    </div>
                    <div className="row mt-2">
                        <img src="/../images/privilege/congratulations.svg" alt="icon"/>
                    </div>
                </div>
            </div>
        </Layout>
    )
};
export default Dacquyen;